module.exports = __webpack_public_path__ + "static/media/precalculus-completed.3a188bbf.svg";